import { Dispatch } from "redux";
import { AppRegisterInfo } from "@app/redux/models";
import AuthService from "@app/redux/services/auth";
import TokenService from "@app/redux/services/token";
import { AppDispatch, AppThunk } from "@app/redux/store/root";
import { getUserRole } from "@app/utils/role";
import { UPDATE_API_FETCHING } from "../api_details";
import {
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGOUT,
    REFRESH_TOKEN,
    UPDATE_EMAIL_OPTED,
    GET_ACCOUNT_STATUS,
    FETCH_USER_DATA,
} from "./types";

export const login =
    (username: string, password: string, keepMeLoggedIn: boolean): AppThunk =>
    (dispatch): Promise<void> => {
        return AuthService.login(username, password, keepMeLoggedIn)
            .then((response) => {
                const data = response.data.data;
                const userRole = getUserRole(data);

                // TokenService.setUserS(data);
                TokenService.setUser({
                    accessToken: data.accessToken,
                    refreshToken: data.refreshToken,
                    // roles: data.roles,
                });
                console.log("data :>> ", data);
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: {
                        user: data,
                        userRole,
                    },
                });

                return Promise.resolve(userRole);
            })
            .catch((error) => {
                TokenService.removeUser();

                dispatch({
                    type: LOGIN_FAIL,
                    payload: { error },
                });

                return Promise.reject(error);
            });
    };

export const registerUser =
    (data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<AppRegisterInfo> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await AuthService.register(data);

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const logout =
    () =>
    async (dispatch: AppDispatch): Promise<void> => {
        const userDetails = TokenService.getUser();

        await AuthService.logout(userDetails.refreshToken);

        TokenService.removeUser();

        dispatch({
            type: LOGOUT,
        });
    };

export const refreshToken =
    (accessToken: string) =>
    (dispatch: AppDispatch): void => {
        dispatch({
            type: REFRESH_TOKEN,
            payload: accessToken,
        });
    };

export const updateEmailOpted =
    (emailOpted: boolean) =>
    async (dispatch: Dispatch): Promise<void> => {
        await AuthService.updateProfileNotification(emailOpted);

        dispatch({
            type: UPDATE_EMAIL_OPTED,
            payload: emailOpted,
        });
    };

export const getAccountStatus =
    (code: string) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await AuthService.getAccountVerificationStatus(code);

            dispatch({
                type: GET_ACCOUNT_STATUS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const fetchUserData =
    () =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const accessToken = TokenService.getLocalAccessToken();
            const refreshToken = TokenService.getLocalRefreshToken();

            const response = await AuthService.getUserData(accessToken);

            dispatch({
                type: FETCH_USER_DATA,
                payload: {
                    ...response.data.data,
                    accessToken,
                    refreshToken,
                },
            });

            return Promise.resolve(response.data.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };
